import state from './rewardListState'
import getters from './rewardListGetters'
import actions from './rewardListActions'
import mutations from './rewardListMutations'

export default {
  namespaced : true,
  state : state,
  getters : getters,
  actions : actions,
  mutations : mutations
}
